import { useEffect, useState, RefObject } from 'react';

export const useScrollbarHeight = (ref: RefObject<HTMLDivElement>) => {
  const [scrollbarHeight, setScrollbarHeight] = useState(0);

  useEffect(() => {
    if (ref.current) {
      const hasOverflow = ref.current.scrollWidth > ref.current.clientWidth;
      if (hasOverflow) {
        setScrollbarHeight(ref.current.offsetHeight - ref.current.clientHeight);
      } else {
        setScrollbarHeight(0);
      }
    }
  }, [ref]);

  return scrollbarHeight;
};
